import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { services } from '../data/site';

type Page = 'home' | 'services' | 'case-studies' | 'industries' | 'about' | 'insights' | 'contact';

export function Services({ onNavigate }: { onNavigate: (page: Page) => void }) {
  return (
    <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <div className="max-w-4xl">
        <p className="section-eyebrow">Services</p>
        <h1 className="section-title">Enterprise platform consulting for API-first, cloud-native businesses.</h1>
        <p className="mt-5 text-lg leading-8 text-slate-600">
          From architecture assessment to hands-on delivery, SVK Limited helps organisations modernise legacy systems,
          build secure platform foundations, and accelerate digital product delivery.
        </p>
      </div>

      <div className="mt-12 grid gap-6">
        {services.map((service) => (
          <article key={service.title} className="rounded border border-slate-200 bg-white p-6 shadow-soft">
            <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr]">
              <div>
                <service.icon className="text-cyan" size={32} aria-hidden="true" />
                <h2 className="mt-5 text-2xl font-bold">{service.title}</h2>
                <p className="mt-3 text-base leading-7 text-slate-600">{service.summary}</p>
              </div>
              <div className="grid gap-6 md:grid-cols-2">
                <div>
                  <h3 className="text-sm font-bold uppercase tracking-[0.16em] text-slate-500">Engineering scope</h3>
                  <ul className="mt-4 grid gap-2">
                    {service.capabilities.map((item) => (
                      <li key={item} className="flex gap-2 text-sm text-slate-700">
                        <CheckCircle2 className="mt-0.5 shrink-0 text-cyan" size={17} />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h3 className="text-sm font-bold uppercase tracking-[0.16em] text-slate-500">Business outcomes</h3>
                  <ul className="mt-4 grid gap-2">
                    {service.outcomes.map((item) => (
                      <li key={item} className="flex gap-2 text-sm text-slate-700">
                        <CheckCircle2 className="mt-0.5 shrink-0 text-cyan" size={17} />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-10 rounded bg-ink p-8 text-white">
        <h2 className="text-2xl font-bold">Need a platform review before committing to delivery?</h2>
        <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-300">
          Use a focused API modernisation review or cloud architecture assessment to clarify risk, priorities, and the
          next practical investment.
        </p>
        <button className="btn-primary mt-6" onClick={() => onNavigate('contact')}>
          Discuss your platform <ArrowRight size={18} aria-hidden="true" />
        </button>
      </div>
    </section>
  );
}
